module.exports = __webpack_public_path__ + "static/media/adult.9c653fcc.png";